"use server";

import prisma from "../../infrastructure/prisma";
import bcrypt from "bcryptjs";
import { createSession, SessionPayload } from "../../lib/auth/session";

export interface LoginResult {
  success: boolean;
  error?: string;
}

export async function loginAction(formData: FormData): Promise<LoginResult> {
  const email = formData.get("email") as string;
  const password = formData.get("password") as string;

  if (!email || !password) {
    return { success: false, error: "이메일과 비밀번호를 모두 입력해 주세요." };
  }

  try {
    // 1. Fetch user by email
    const adminUser = await prisma.adminUser.findUnique({
      where: { email },
      include: {
        branch: {
          include: { brand: true },
        },
        brand: true,
        role: {
          include: {
            permissions: {
              include: {
                permission: true,
              },
            },
          },
        },
      },
    });

    if (!adminUser) {
      return { success: false, error: "이메일 또는 비밀번호가 올바르지 않습니다." };
    }

    if (adminUser.status !== "ACTIVE") {
      return { success: false, error: "비활성화되었거나 승인 대기 중인 계정입니다." };
    }

    // 2. Validate password
    const isPasswordValid = bcrypt.compareSync(password, adminUser.passwordHash);
    if (!isPasswordValid) {
      return { success: false, error: "이메일 또는 비밀번호가 올바르지 않습니다." };
    }

    // Update lastLoginAt
    await prisma.adminUser.update({
      where: { id: adminUser.id },
      data: { lastLoginAt: new Date() },
    });

    // 3. Prepare session payload
    const permissions = adminUser.role.permissions.map((rp) => rp.permission.action);
    const resolvedBrandId = adminUser.brandId || adminUser.branch?.brandId || null;

    const sessionPayload: SessionPayload = {
      userId: adminUser.id,
      email: adminUser.email,
      name: adminUser.name,
      profileUrl: adminUser.profileUrl || null,
      roleName: adminUser.role.name,
      branchId: adminUser.branchId,
      brandId: resolvedBrandId,
      permissions,
    };

    // 4. Create cookie session
    await createSession(sessionPayload);

    return { success: true };
  } catch (error: any) {
    console.error("[Login Action Error]", error);
    return { success: false, error: "로그인 처리 도중 서버 오류가 발생했습니다." };
  }
}
